const activeMemberships = memberships =>
  (memberships || []).filter(membership => membership?.is_active !== false);

export function getAppointmentAccess(appointment, userId, memberships = []) {
  if (!appointment || !userId) return { canEdit: false, canViewFee: false };
  if (appointment.doctor_id === userId) return { canEdit: true, canViewFee: true };

  const membership = activeMemberships(memberships).find(
    item => item.clinic_id === appointment.clinic_id
  );
  const canEdit = Boolean(
    appointment.clinic_id && membership && ["admin", "receptionist"].includes(membership.role)
  );
  return { canEdit, canViewFee: canEdit };
}

export function getFinancialScope(activeMode, memberships = [], isReceptionistOnly = false) {
  const active = activeMemberships(memberships);
  const denied = {
    canAccessFinancials: false,
    includePersonal: false,
    includedClinicIds: [],
  };

  if (!activeMode || isReceptionistOnly) return denied;
  if (activeMode === "personal") {
    return { canAccessFinancials: true, includePersonal: true, includedClinicIds: [] };
  }
  if (activeMode === "everything") {
    return {
      canAccessFinancials: true,
      includePersonal: true,
      includedClinicIds: [...new Set(
        active.filter(item => ["admin", "consultant"].includes(item.role)).map(item => item.clinic_id)
      )],
    };
  }

  const membership = active.find(item => item.clinic_id === activeMode);
  if (!membership || !["admin", "consultant"].includes(membership.role)) return denied;
  return {
    canAccessFinancials: true,
    includePersonal: false,
    includedClinicIds: [activeMode],
  };
}
